var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint react/prop-types: 0 */

import React from "react";
import { Badge } from "react-bootstrap";
import { oneOf } from "prop-types";

BadgeWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Adds theme based style
   */
  bsStyle: oneOf(["primary", "info", "success", "danger", "warning"])
} : {};

function BadgeWrapper(props) {
  var reactBootstrapProps = _extends({}, props);

  delete reactBootstrapProps.bsStyle;

  var classnames = [props.className ? props.className : "", props.bsStyle ? "badge-" + props.bsStyle : ""].join(" ");

  return React.createElement(Badge, _extends({}, reactBootstrapProps, { className: classnames }));
}

export default BadgeWrapper;